<template>
    <div class="table-edit-input">
        <el-popover placement="top" width="200" trigger="manual" v-model="editShow">
            <el-link type="primary" slot="reference" @click="editShow = !editShow">{{info[propsName]}} <i class="el-icon-edit"></i></el-link>
            <div class="change-box">
                <el-input v-model="info[propsName]" size="mini" clearable></el-input>
            </div>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="editShow = false">取消</el-button>
                <el-button type="primary" size="mini" @click="sub">确定</el-button>
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    data() {
        return {
            editShow: false
        }
    },
    props: {
        info:Object,
        propsName:String,
        url:String
    },
    methods: {
        sub() {
            this.$util.put(this.url + '/' + this.info.id, {
                field: this.propsName,
                value: this.info[this.propsName]
            }).then(() => {
                this.editShow = false
                this.$emit('subQuick')
            })
        }
    }
}
</script>

<style scoped>
.change-box{
    margin-bottom: 10px;
}
</style>